import { ShieldX } from "lucide-react";

import styles from "./AccessDenied.module.css";

export const AccessDenied = () => (
  <div className={styles.box}>
    <div className={styles.state}>
      <ShieldX size={56} className={styles.icon} />
      <p className={styles.title}>Access denied</p>
      <p className={styles.text}>
        You do not have permission to view this page. Please contact your
        administrator if you believe this is an error.
      </p>
    </div>
  </div>
);
